<template>
    <v-data-table
            :loading="loading"
            no-data-text="Нет элементов"
            no-results-text="Не найдено элементов"
            loading-text="Загрузка данных"
            calculate-widths
            :items-per-page="filteredItems.length"
            :items="filteredItems"
            :headers="fields"
            :search="search"
            sort-by="applyDate"
            sort-desc
            height="100%"
            hide-default-footer
            class="elevation-0 h-100 "
    >
        <template v-slot:item.bonus="{item}">
            <span style="font-weight: 600">{{item.bonus}}</span>
        </template>
        <template v-slot:item.bonusPacket="{item}">
            <div :class="{'bonus-container':true,'bonus-1':item.bonusPacketCode=='BP01','bonus-2':item.bonusPacketCode=='BP02', 'bonus-3':item.bonusPacketCode=='BP03','bonus-0':item.bonusPacketCode=='BP00'}"><div>{{item.bonusPacket}}</div></div>
        </template>
        <template v-slot:item.applyDate="{item}">
            <span>{{formatDateMounthName(item.applyDate)}}</span>
        </template>
    </v-data-table>
</template>

<script>
    export default {
        name: "ActivationsList",
        props:{
            search:{
                type:String,
                default:''
            },
            isLimit:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return {
                loading:false,
                fields:[
                    {text: 'Бонус', value: 'bonus'},
                    {text: 'ФИО клиента', value: 'client'},
                    {text: 'Машина', value: 'clientCar'},
                    {text: 'Пакет', value: 'bonusPacket'},
                    {text: 'Партнер', value: 'organization'},
                    {text: 'Адрес', value: 'orgGeoInfo'},
                    {text: 'Списал', value: 'webUser'},
                    {text: 'Дата списания', value: 'applyDate'},
                ]
            }
        },
        mounted(){
            this.getActivationItems()
        },
        computed:{
            filteredItems(){
                return this.$store.state.Statistic.activatesList
            }
        },
        methods:{
            getActivationItems(){
                this.$store.dispatch("Statistic/loadActivatesList", this.isLimit).catch(err=>{
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки истории активации!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            }
        }
    }
</script>

<style scoped>

</style>